import {
  VERIFICATION_STATUSES,
  VERIFICATION_DATA_SOURCES,
  VERIFICATION_ATTEMPT_TYPES,
  USER_VERIFICATION_ATTEMPT_STATUSES,
} from "@/features/account/types/Verification";
import { z } from "zod";

const verificationDataSourceSchema = z.object({
  displayOrder: z.number().nullable(),
  name: z.string(),
  status: z.enum(VERIFICATION_STATUSES),
  sufficient: z.boolean().nullish(),
});

const userVerificationsStatus = z.object({
  ready: z.boolean(),
});

const userVerifications = z.object({
  id: z.string(),
  status: z.string(),
  dataSources: z.partialRecord(
    z.enum(VERIFICATION_DATA_SOURCES),
    verificationDataSourceSchema,
  ),
});

const userVerificationAttemptDataSource = z.object({
  name: z.string(),
  status: z.enum(USER_VERIFICATION_ATTEMPT_STATUSES),
  sufficient: z.boolean().nullish(),
});

type UserVerificationAttemptDataSource = z.infer<
  typeof userVerificationAttemptDataSource
>;

const userVerificationAttempt = z.object({
  dataSources: z
    .partialRecord(
      z.enum(VERIFICATION_DATA_SOURCES),
      userVerificationAttemptDataSource,
    )
    .nullish(),
  maxSourcesRequired: z.number().nullish(),
  attemptStatus: z.enum(USER_VERIFICATION_ATTEMPT_STATUSES),
  attemptType: z.enum(VERIFICATION_ATTEMPT_TYPES),
  destination: z.string().nullish(),
  accessToken: z.string().nullish(), // Sumsub access token for the WebSDK
  updatedAt: z.iso.datetime().nullish(),
  expiryAt: z.iso.datetime().nullish(),
});

/** The object containing data for the respective verification data source */
type VerificationDataSourceSchema = z.infer<
  typeof verificationDataSourceSchema
>;
type UserVerifications = z.infer<typeof userVerifications>;

export {
  userVerifications,
  userVerificationAttempt,
  userVerificationsStatus,
  type UserVerifications,
  type VerificationDataSourceSchema,
  type UserVerificationAttemptDataSource,
};
